import { render, staticRenderFns } from "./SisClassroomStudent.vue?vue&type=template&id=5be4c9a0&"
import script from "./SisClassroomStudent.vue?vue&type=script&lang=ts&"
export * from "./SisClassroomStudent.vue?vue&type=script&lang=ts&"
import style0 from "./SisClassroomStudent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports